var _polygon, _line, _line2, _line3, _line4, _polyline, _line5, _line6, _line7, _line8, _polygon2, _polyline2, _line9, _polyline3, _polyline4, _polyline5, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _path, _path2, _line30, _line31, _path3, _path4, _line32, _line33, _path5, _path6, _line34, _line35, _path7, _path8, _line36, _line37, _path9, _path10, _line38, _line39, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _line70, _line71, _line72, _line73, _line74, _line75, _line76, _line77, _line78, _line79, _line80, _line81, _line82, _line83, _line84, _polyline6, _line85, _line86, _polyline7, _line87, _line88, _path19, _path20, _polyline8, _polyline9, _line89, _line90, _rect, _path21, _line91, _line92, _line93, _line94, _line95, _line96, _line97, _line98, _line99, _line100, _line101, _line102, _line103, _line104, _line105, _line106, _line107, _line108, _line109, _line110, _line111, _line112;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChassisTopView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1135 217.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "39.995 16.268 39.995 198.286 23.256 198.286 23.256 16.554 39.995 16.268",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23.419,
    y1: 43.996,
    x2: 39.448,
    y2: 43.996,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 24.079,
    y1: 88.782,
    x2: 40.108,
    y2: 88.782,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 22.948,
    y1: 125.553,
    x2: 38.976,
    y2: 125.553,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 22.759,
    y1: 169.679,
    x2: 38.788,
    y2: 169.679,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "23.072 67.605 16.632 71.928 16.632 144.706 22.7 148.933",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 40.038,
    y1: 68.277,
    x2: 1099.649,
    y2: 68.277,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 40.146,
    y1: 79.231,
    x2: 1099.757,
    y2: 79.231,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 39.747,
    y1: 135.027,
    x2: 1099.357,
    y2: 135.027,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 39.855,
    y1: 145.981,
    x2: 1099.465,
    y2: 145.981,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "1114.931 15.723 1114.931 197.742 1100.412 197.742 1100.412 16.009 1114.931 15.723",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "1114.221 31.617 1100.875 31.617 1063.619 68.402",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 1089.015,
    y1: 106.822,
    x2: 1125.78,
    y2: 106.822,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "1115.027 182.657 1101.681 182.657 1064.154 145.544",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "1115.779 68.495 1123.125 68.495 1123.125 79.68 1115.583 79.68",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    points: "1115.408 135.035 1122.754 135.035 1122.754 146.22 1115.212 146.22",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 892.792,
    y1: 78.858,
    x2: 892.792,
    y2: 134.427,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 901.503,
    y1: 79.534,
    x2: 901.503,
    y2: 135.103,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 936.647,
    y1: 79.985,
    x2: 936.647,
    y2: 135.554,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 994.513,
    y1: 79.024,
    x2: 994.513,
    y2: 134.593,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 1003.224,
    y1: 79.7,
    x2: 1003.224,
    y2: 135.269,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 1078.528,
    y1: 78.667,
    x2: 1078.528,
    y2: 134.236,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 333.091,
    y1: 79.358,
    x2: 333.091,
    y2: 134.928,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 341.802,
    y1: 80.034,
    x2: 341.802,
    y2: 135.603,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 314.098,
    y1: 78.219,
    x2: 314.098,
    y2: 133.788,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 322.809,
    y1: 78.894,
    x2: 322.809,
    y2: 134.464,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 282.125,
    y1: 79.69,
    x2: 282.125,
    y2: 135.259,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 288.836,
    y1: 80.366,
    x2: 288.836,
    y2: 135.935,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 257.662,
    y1: 78.55,
    x2: 257.662,
    y2: 134.119,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 264.373,
    y1: 79.226,
    x2: 264.373,
    y2: 134.795,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 229.372,
    y1: 79.722,
    x2: 229.372,
    y2: 135.291,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 236.082,
    y1: 80.398,
    x2: 236.082,
    y2: 135.967,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 202.57,
    y1: 78.956,
    x2: 202.57,
    y2: 134.525,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 209.281,
    y1: 79.632,
    x2: 209.281,
    y2: 135.201,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 173.638,
    y1: 77.99,
    x2: 173.638,
    y2: 133.559,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 180.349,
    y1: 78.665,
    x2: 180.349,
    y2: 134.235,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m406.395,79.02s-.812,6.33,5.837,8.31v38.889s-6.986,2.002-6.543,7.937",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m426.364,79.116s.812,6.33-5.837,8.31v38.889s5.81,1.584,5.81,7.865",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 420.527,
    y1: 87.426,
    x2: 412.232,
    y2: 87.331,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 412.232,
    y1: 126.22,
    x2: 420.527,
    y2: 126.315,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m498.084,79.974s-.812,6.33,5.837,8.31v38.889s-6.986,2.002-6.543,7.937",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m518.053,80.07s.812,6.33-5.837,8.31v38.889s5.81,1.584,5.81,7.865",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 512.216,
    y1: 88.38,
    x2: 503.922,
    y2: 88.285,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 503.922,
    y1: 127.174,
    x2: 512.216,
    y2: 127.269,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m588.795,78.78s-.812,6.33,5.837,8.31v38.889s-6.986,2.002-6.543,7.937",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m608.764,78.876s.812,6.33-5.837,8.31v38.889s5.81,1.584,5.81,7.865",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 602.926,
    y1: 87.186,
    x2: 594.632,
    y2: 87.09,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 594.632,
    y1: 125.979,
    x2: 602.926,
    y2: 126.075,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m677.881,78.922s-.812,6.33,5.837,8.31v38.889s-6.986,2.002-6.543,7.937",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m697.85,79.017s.812,6.33-5.837,8.31v38.889s5.81,1.584,5.81,7.865",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 692.013,
    y1: 87.328,
    x2: 683.718,
    y2: 87.232,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 683.718,
    y1: 126.121,
    x2: 692.013,
    y2: 126.217,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m768.373,79.432s-.812,6.33,5.837,8.31v38.889s-6.986,2.002-6.543,7.937",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m788.342,79.528s.812,6.33-5.837,8.31v38.889s5.81,1.584,5.81,7.865",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 782.505,
    y1: 87.838,
    x2: 774.21,
    y2: 87.742,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 774.21,
    y1: 126.631,
    x2: 782.505,
    y2: 126.727,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m899.323,57.075v-13.871s-.161-3.082,3.223-3.082h75.903s3.868.925,3.868,3.699v13.255s.161,3.853-4.029,3.853h-75.903s-3.062-.925-3.062-3.853Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m899.615,31.48v-12.981s-.161-2.885,3.223-2.885h75.903s3.868.865,3.868,3.462v12.404s.161,3.606-4.029,3.606h-75.903s-3.062-.865-3.062-3.606Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m1004.79,31.869v-12.981s-.161-2.885,3.223-2.885h75.903s3.868.865,3.868,3.462v12.404s.161,3.606-4.029,3.606h-75.903s-3.062-.865-3.062-3.606Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m899.486,195.501v-13.871s-.161-3.082,3.223-3.082h75.903s3.868.925,3.868,3.699v13.255s.161,3.853-4.029,3.853h-75.903s-3.062-.925-3.062-3.853Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m899.778,169.907v-12.981s-.161-2.885,3.223-2.885h75.903s3.868.865,3.868,3.462v12.404s.161,3.606-4.029,3.606h-75.903s-3.062-.865-3.062-3.606Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m1005.071,195.056v-12.981s-.161-2.885,3.223-2.885h75.903s3.868.865,3.868,3.462v12.404s.161,3.606-4.029,3.606h-75.903s-3.062-.865-3.062-3.606Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m1071.605,60.666h-64.26c-3.915,0-3.724-3.637-3.724-3.637l.286-15.201s-.945-2.587,3.489-2.033,76.665,0,76.665,0c0,0,1.321-.247,2.114,1.074s.115,5.334.115,5.334",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m1071.946,153.18h-64.26c-3.915,0-3.724,3.637-3.724,3.637l.286,15.201s-.945,2.587,3.489,2.033,76.665,0,76.665,0c0,0,1.321.247,2.114-1.074s.115-5.334.115-5.334",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 933.863,
    y1: 68.119,
    x2: 933.863,
    y2: 61.038,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 947.394,
    y1: 69.22,
    x2: 947.394,
    y2: 62.14,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 926.468,
    y1: 41.057,
    x2: 926.468,
    y2: 33.977,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 955.261,
    y1: 41.371,
    x2: 955.261,
    y2: 34.291,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 1032.058,
    y1: 41.318,
    x2: 1032.058,
    y2: 34.238,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 1060.278,
    y1: 41.414,
    x2: 1060.278,
    y2: 34.334,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 1039.107,
    y1: 67.653,
    x2: 1039.107,
    y2: 60.572,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 1053.212,
    y1: 68.339,
    x2: 1053.212,
    y2: 61.259,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 934.235,
    y1: 154.175,
    x2: 934.235,
    y2: 147.095,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 947.941,
    y1: 153.865,
    x2: 947.941,
    y2: 146.785,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 926.527,
    y1: 179.768,
    x2: 926.527,
    y2: 172.688,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 955.207,
    y1: 179.922,
    x2: 955.207,
    y2: 172.842,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 1039.467,
    y1: 153.489,
    x2: 1039.467,
    y2: 146.409,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 1053.347,
    y1: 152.723,
    x2: 1053.347,
    y2: 145.643,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 1032.052,
    y1: 180.409,
    x2: 1032.052,
    y2: 173.329,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 1060.932,
    y1: 180.177,
    x2: 1060.932,
    y2: 173.097,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 40.386,
    y1: 36.598,
    x2: 66.397,
    y2: 67.837,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 40.017,
    y1: 177.743,
    x2: 66.029,
    y2: 146.505,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 137.136,
    y1: 79.551,
    x2: 137.136,
    y2: 135.12,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 152.887,
    y1: 80.227,
    x2: 152.887,
    y2: 135.796,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: 98.093,
    y1: 79.952,
    x2: 98.093,
    y2: 135.521,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    x1: 118.841,
    y1: 80.746,
    x2: 118.841,
    y2: 136.315,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    x1: 78.611,
    y1: 79.097,
    x2: 78.611,
    y2: 134.667,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    x1: 96.494,
    y1: 117.011,
    x2: 117.993,
    y2: 117.011,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    x1: 137.252,
    y1: 117.349,
    x2: 154.123,
    y2: 117.349,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    x1: 158.433,
    y1: 107.293,
    x2: 201.751,
    y2: 107.293,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    x1: 97.109,
    y1: 107.42,
    x2: 143.045,
    y2: 107.42,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    x1: 41.025,
    y1: 97.299,
    x2: 77.729,
    y2: 97.299,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    x1: 40.526,
    y1: 117.517,
    x2: 77.23,
    y2: 117.517,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    x1: 40.221,
    y1: 107.13,
    x2: 85.211,
    y2: 107.13,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    x1: 10.797,
    y1: 107.378,
    x2: 27.668,
    y2: 107.378,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    x1: 216.089,
    y1: 107.006,
    x2: 257.648,
    y2: 107.006,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    x1: 274.137,
    y1: 107.174,
    x2: 317.948,
    y2: 107.174,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    x1: 333.583,
    y1: 106.882,
    x2: 377.394,
    y2: 106.882,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    x1: 391.413,
    y1: 107.383,
    x2: 435.224,
    y2: 107.383,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    x1: 448.867,
    y1: 107.235,
    x2: 492.678,
    y2: 107.235,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    x1: 508.54,
    y1: 107.565,
    x2: 552.351,
    y2: 107.565,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    x1: 565.297,
    y1: 107.02,
    x2: 609.108,
    y2: 107.02,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    x1: 623.194,
    y1: 106.911,
    x2: 667.005,
    y2: 106.911,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    x1: 683.295,
    y1: 107.292,
    x2: 724.752,
    y2: 107.292,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    x1: 739.383,
    y1: 107.455,
    x2: 783.195,
    y2: 107.455,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    x1: 797.953,
    y1: 106.995,
    x2: 841.764,
    y2: 106.995,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    x1: 856.275,
    y1: 107.082,
    x2: 907.783,
    y2: 107.082,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    x1: 913.993,
    y1: 106.856,
    x2: 957.804,
    y2: 106.856,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    x1: 1029.139,
    y1: 107.383,
    x2: 1072.95,
    y2: 107.383,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    points: "314.104 67.259 314.104 43.773 342.19 43.773 342.19 67.378",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    x1: 322.417,
    y1: 44.231,
    x2: 322.417,
    y2: 67.249,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    x1: 333.337,
    y1: 45.016,
    x2: 333.337,
    y2: 68.035,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    points: "313.828 147.018 313.828 170.759 341.645 170.759 341.645 146.898",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    x1: 321.872,
    y1: 170.308,
    x2: 321.872,
    y2: 147.279,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    x1: 332.792,
    y1: 169.534,
    x2: 332.792,
    y2: 146.845,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m1047.232,79.275c-7.202-.883-8.294,5.329-8.294,5.329v44.697s1.924,4.615,10.334,5.682",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m1055.643,79.239c7.202-.883,8.294,5.329,8.294,5.329v44.697s-1.924,4.615-10.334,5.682",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    points: "1039.225 102.31 1026.816 88.977 1003.45 102.838",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    points: "1039.388 112.123 1026.979 125.456 1003.614 111.595",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    x1: 1004.027,
    y1: 102.733,
    x2: 1037.731,
    y2: 102.733,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    x1: 1004.241,
    y1: 111.479,
    x2: 1037.944,
    y2: 111.479,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1017.325,
    y: 103.333,
    width: 8.175,
    height: 6.899
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m962.952,126.386s-5.871.927-10.917.309-7.107-3.502-7.107-3.502v-32.134s2.678-3.914,8.755-3.605h9.269s7.313-.206,7.416,4.017,0,31.722,0,31.722c0,0-1.648,2.575-7.416,3.193Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    x1: 953.683,
    y1: 87.454,
    x2: 953.683,
    y2: 79.462,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    x1: 962.952,
    y1: 87.454,
    x2: 962.952,
    y2: 79.007,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    x1: 952.035,
    y1: 126.695,
    x2: 952.035,
    y2: 134.261,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    x1: 962.952,
    y1: 126.386,
    x2: 962.952,
    y2: 134.149,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    x1: 970.866,
    y1: 101.494,
    x2: 993.675,
    y2: 101.494,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    x1: 971.403,
    y1: 110.988,
    x2: 994.212,
    y2: 110.988,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    x1: 32.289,
    y1: 107.447,
    x2: 35.845,
    y2: 107.447,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    x1: 90.605,
    y1: 107.043,
    x2: 94.161,
    y2: 107.043,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    x1: 149.086,
    y1: 107.381,
    x2: 152.642,
    y2: 107.381,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    x1: 265.753,
    y1: 107.037,
    x2: 269.309,
    y2: 107.037,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    x1: 324.071,
    y1: 107.126,
    x2: 327.627,
    y2: 107.126,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    x1: 381.078,
    y1: 107.011,
    x2: 384.634,
    y2: 107.011,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line103 || (_line103 = /*#__PURE__*/React.createElement("line", {
    x1: 439.577,
    y1: 107.303,
    x2: 443.133,
    y2: 107.303,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line104 || (_line104 = /*#__PURE__*/React.createElement("line", {
    x1: 497.396,
    y1: 107.185,
    x2: 500.952,
    y2: 107.185,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line105 || (_line105 = /*#__PURE__*/React.createElement("line", {
    x1: 556.106,
    y1: 107.072,
    x2: 559.662,
    y2: 107.072,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line106 || (_line106 = /*#__PURE__*/React.createElement("line", {
    x1: 613.933,
    y1: 107.153,
    x2: 617.489,
    y2: 107.153,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line107 || (_line107 = /*#__PURE__*/React.createElement("line", {
    x1: 672.051,
    y1: 107.163,
    x2: 675.607,
    y2: 107.163,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line108 || (_line108 = /*#__PURE__*/React.createElement("line", {
    x1: 730.599,
    y1: 107.475,
    x2: 734.155,
    y2: 107.475,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line109 || (_line109 = /*#__PURE__*/React.createElement("line", {
    x1: 788.416,
    y1: 107.019,
    x2: 791.972,
    y2: 107.019,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line110 || (_line110 = /*#__PURE__*/React.createElement("line", {
    x1: 846.509,
    y1: 107.096,
    x2: 850.065,
    y2: 107.096,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line111 || (_line111 = /*#__PURE__*/React.createElement("line", {
    x1: 963.153,
    y1: 106.973,
    x2: 966.709,
    y2: 106.973,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line112 || (_line112 = /*#__PURE__*/React.createElement("line", {
    x1: 1079.712,
    y1: 106.945,
    x2: 1083.268,
    y2: 106.945,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChassisTopView);
export default __webpack_public_path__ + "static/media/chassis-top-view.4d3da0ed108493dc8a66ec26f2397d84.svg";
export { ForwardRef as ReactComponent };